import { h } from "vue"
import { RouterLink } from "vue-router"
import { DateTime } from "luxon"
import { UseTimeAgo } from "@vueuse/components"
import { NButton, NotificationApi, NotificationOptions } from "naive-ui"
import { GroupInvitePayload, Notification, NotificationType } from "@/types/models/notification"
import NotificationContent from "@/components/notifications/NotificationContent.vue"
import Avatar from "@/components/users/Avatar.vue"
import http from "@/http"

export const createNotification = (api: NotificationApi, notification: Notification, options?: NotificationOptions) => {
  const date = DateTime.fromISO(notification.creationDate, { zone: "UTC" }).toJSDate()

  const base: NotificationOptions = {
    duration: 5000,
    meta: () => h(UseTimeAgo, {
      time: date
    }, {
      default: ({ timeAgo }: { timeAgo: string }) => timeAgo
    })
  }
  
  switch(notification.type) {
    case NotificationType.GroupInvite:
      return getGroupInviteOptions(api, notification, base, options)
  }
}

export const getGroupInviteOptions = (
  api: NotificationApi,
  notification: Notification<GroupInvitePayload>,
  base?: NotificationOptions,
  overwrite?: NotificationOptions
) => {
  const instance = api.create(getOptions({
    avatar: () => h(Avatar, { user: notification.payload.user, size: 28, fontSize: 12 }),
    title: "Group invitation",
    content: () => h(NotificationContent, { notification, depth: 3 }),
    action: () => h(RouterLink, {
      to: {
        name: "Invitation",
        params: { token: notification.payload.token }
      },
      class: "text-decoration-none"
    }, {
      default: () => h(NButton, {
        type: "info",
        size: "small",
        onClick: () => {
          silentRead([notification.userNotificationId])
          instance.destroy()
        }
      }, {
        default: () => "View"
      })
    })
  }, base, overwrite))

  return instance
}

export const silentRead = async (ids: number[]) => {
  try {
    await http.post("users/readnotification", {
      userNotificationId: ids
    })
  }
  catch(error) {
    console.warn(error)
  }
}

const getOptions = (options: NotificationOptions, base?: NotificationOptions, overwrite?: NotificationOptions) => ({
  ...base,
  ...options,
  ...overwrite
})
